import script from "./ChatResourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatResourceView.vue?vue&type=script&setup=true&lang=js"

import "./ChatResourceView.vue?vue&type=style&index=0&id=54405a39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54405a39"]])

export default __exports__